<template>
  <div class="set">
    <div v-if="loading">loading ...</div>
    <div v-if="!access">no access ...</div>
    <section class="set-container" v-else>
      <h1 class="set-heading">Channel Settings</h1>
      <h2 class="set-subheading">Channel Name</h2>
      <h3 class="set-value">{{channel.name}}</h3>
      <h2 class="set-subheading">Channel Description</h2>
      <h3 class="set-value">{{channel.description}}</h3>
      <h2 class="set-subheading">Account Email</h2>
      <h3 class="set-value">{{user.email}}</h3>
      <div class="pricing">
        <h2 class="set-subheading">Pricing</h2>
        <pricing/>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Pricing from './Pricing'

export default {
  name: 'ChannelSettings',
  components: {
    Pricing,
  },
  props: {
  },
  data () {
    return {
      editingTier: '',
      editingTierName: '',
      editingTierPrice: null,
      pricing: {
        cost: 999
      }
    }
  },
  computed: {
    ...mapState(['user', 'channel']),
    access () {
      return this.user.uid === this.channel.owner
    },
    loading () {
      return !this.user || !this.channel
    },
    tiers () {
      let ourTiers = []
      if (this.channel.tiers) {
        for (let key in this.channel.tiers) {
          let val = this.channel.tiers[key]
          val.name = key
          ourTiers.push(val)
        }
      }

      return ourTiers
    }
  },
  methods: {
    editTier(tier) {
      this.editingTier = tier.name
      this.editingTierName = tier.name
      this.editingTierPrice = tier.price
    },
    onChange () {

    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .set-container {
    max-width: $maxWidth--wide;
    margin: $unit-3 auto;
  }

  .set-heading {
    @include text('heading');
  }

  .set-subheading {
    @include caps;
  }

  .set-value {
    @inclu text('body');
    margin-bottom: $unit-2;
  }

  .pricing {
    margin-top: $unit-1;
  }

</style>
